import React from 'react';
import { connect } from 'react-redux';
import { selectConfig } from '../../../redux/config/selectors';
import Logo from '../../Logo/Logo';
import { logout } from '../../../redux/authentication/slice';
import { Button } from '../../ui/Button/Button';
import { OnboardingNavbarWrapper } from '../../ui/Layout/OnboardingLayout';

export const OnboardingNavbarComponent = ({
  config,
  logout,
  onLogout,
  logoutLabel = 'Speichern & Abmelden',
  loading
}) => {
  const handleLogout = onLogout || logout;

  return (
    <OnboardingNavbarWrapper>
      <Logo
        agencyLogo={config?.tenant_logo?.url_small || config?.tenant_logo?.url}
        agencyName={config?.tenant_name}
        className="onboarding"
      />
      <Button type="link" onClick={handleLogout} disabled={loading}>
        {logoutLabel}
      </Button>
    </OnboardingNavbarWrapper>
  );
};

const mapStateToProps = (state) => ({
  config: selectConfig(state)
});

const mapDispatchToProps = {
  logout
};

export const OnboardingNavbar = connect(mapStateToProps, mapDispatchToProps)(OnboardingNavbarComponent);
